import axios from 'axios';
import moment from 'moment';
import { getSentry } from '@/analytics/sentry';

export default {
    ENROLL_IN_MFA(context, payload) {
        return enrollInMfa(context, payload);
    },

    LOAD_USER_PROFILE(context, payload) {
        return loadUserProfile(context, payload);
    },
};

const enrollInMfa = async ({ commit }, { mfaType }) => {
    try {
        commit('UPDATE_MFA_START');

        const url = `${import.meta.env.VITE_ACCOUNT_CENTRAL_URL}/user/me/mfa`;

        const passwordBody = {};

        passwordBody.mfaType = mfaType;

        await axios.post(url, passwordBody);

        commit('UPDATE_MFA_SUCCESS');
    } catch (error) {
        const sentry = getSentry();
        sentry.captureException(error);

        commit('UPDATE_MFA_ERROR', error);
        throw error;
    }
};

const loadUserProfile = async ({ commit }) => {
    try {
        commit('LOAD_PROFILE_START');
        const url = `${import.meta.env.VITE_ACCOUNT_CENTRAL_URL}/user/me`;
        const response = await axios.get(url);

        const { firstName, lastName, username, mfaProfile, isMigratedToThryv, hasGoogleAccount } = response.data;

        if (mfaProfile?.mfaRegistered?.mfaInvited) {
            const { mfaInvited } = mfaProfile.mfaRegistered;
            commit('LOAD_PROFILE_INVITE_SUCCESS', { mfaInvited });
        }

        if (mfaProfile?.mfaRegistered?.mfaEmail) {
            const { mfaEmail } = mfaProfile.mfaRegistered;

            commit('LOAD_PROFILE_EMAIL_SUCCESS', { mfaEmail });
        } else {
            commit('LOAD_PROFILE_NO_EMAIL');
        }

        if (mfaProfile?.mfaRegistered?.mfaSms) {
            const { mfaSms } = mfaProfile.mfaRegistered;

            commit('LOAD_PROFILE_SMS_SUCCESS', { mfaSms });
        } else {
            commit('LOAD_PROFILE_NO_SMS');
        }

        if (mfaProfile?.mfaRegistered?.mfaAppAuth) {
            const { mfaAppAuth } = mfaProfile.mfaRegistered;

            commit('LOAD_PROFILE_APP_AUTH_SUCCESS', { mfaAppAuth });
        } else {
            commit('LOAD_PROFILE_NO_APP_AUTH');
        }

        if (mfaProfile?.mfaSavedBrowsers?.browsers
            && mfaProfile?.mfaSavedBrowsers?.browsers.length > 0) {
            const { browsers } = mfaProfile.mfaSavedBrowsers;

            browsers.forEach((browser) => {
                browser.dateAdded = moment(browser.dateAdded * 1000).format('LL');
            });

            commit('LOAD_PROFILE_SAVED_BROWSERS_SUCCESS', { browsers });
        } else {
            commit('LOAD_PROFILE_NO_SAVED_BROWSERS');
        }

        if (isMigratedToThryv === true) {
            commit('LOAD_PROFILE_MIGRATION_STATUS', { isMigratedToThryv: true });
        }

        if (hasGoogleAccount === true) {
            commit('LOAD_PROFILE_GOOGLE_ACCOUNT_STATUS', { hasGoogleAccount: true });
        }

        commit('LOAD_PROFILE_SUCCESS', {
            firstName, lastName, username,
        });
    } catch (error) {
        const sentry = getSentry();
        sentry.captureException(error);
        commit('LOAD_PROFILE_ERROR', error);
    }
};
